//#region Imports
import { FormGroup } from '@angular/forms';
import { Helper } from '@rawlings/core';
import { YESNOU_NO, YESNOU_YES } from '@rawlings/enterprise-form';
//#endregion Imports
export class MemberResponseHelper {

    //#region Public Variables
    //#endregion Public Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor
    //#endregion Constructor

    //#region Public Methods
    public static Deserialize<T>(jsonString: string): T | null{
        if(Helper.IsEmpty(jsonString)){
            return null;
        }

        try {
            const obj: any = JSON.parse(jsonString);
            return obj;
        }
        catch{
            return null;
        }
    }

    public static GetBoolFromYesNoValue(value: string): boolean {
        return Helper.CompareIgnoreCase(value, YESNOU_YES) ? true : Helper.CompareIgnoreCase(value, YESNOU_NO) ? false : null;
    }

    public static GetStringForYesNoValue(value: boolean): string {
        return value ? YESNOU_YES : value === false ? YESNOU_NO : null;
    }

    public static GetStringToggleValue(value:any): string{
        if(Helper.IsBoolean(value)){
            return MemberResponseHelper.GetStringForYesNoValue(value);
        }
        return value;
    }

    public static GetBooleanToggleValue(value: any): boolean{
        if(Helper.IsEmpty(value) || Helper.IsBoolean(value)){
            return value;
        }

        return MemberResponseHelper.GetBoolFromYesNoValue(value);
    }

    public static HasFormChanged(form: FormGroup, initialFormValue: any): boolean {
        return JSON.stringify(form.value) !== JSON.stringify(initialFormValue);
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static getDateWithZeroTime(date: string | Date): Date {
        const parsedDate: Date = new Date(date);

        if (!Helper.IsDate(parsedDate) || parsedDate.toISOString().startsWith('1970-01-01')) {
            return null;
        }

        parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    }

    public static GetValidPhoneNumber(phoneNumber : string) : string {
        if(Helper.IsEmpty(phoneNumber))
        {
            return null;
        }

        const phoneNumberRegexString : string = Helper.RegExOptionalPrefix + Helper.RegExPhoneExpression;
        const regex : RegExp = new RegExp(phoneNumberRegexString);
        if(!regex.test(phoneNumber))
        {
            return null;
        }

        return phoneNumber;
    }

    public static GetValidString(value : string) : string {
        if(Helper.IsEmpty(value))
        {
            return null;
        }
        return value;
    }
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
